import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=be7396c4&scoped=true&"
import script from "./prize.vue?vue&type=script&lang=js&"
export * from "./prize.vue?vue&type=script&lang=js&"
import style0 from "./prize.vue?vue&type=style&index=0&id=be7396c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7396c4",
  null
  
)

export default component.exports